export class VerifyStoreRequest {
  verified: boolean;
  tenant: number;
}
